export default __webpack_public_path__ + "static/media/home-button.e4174d56.svg";